var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgRevenue(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7905_5555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19586 1.1958H2.36253L3.91419 8.4408C3.97112 8.70614 4.11875 8.94333 4.33169 9.11155C4.54463 9.27978 4.80956 9.3685 5.08086 9.36247H10.7859C11.0514 9.36204 11.3088 9.27105 11.5156 9.10454C11.7224 8.93802 11.8663 8.70594 11.9234 8.44663L12.8859 4.11247H2.9867M5.25 12.2501C5.25 12.5722 4.98883 12.8334 4.66667 12.8334C4.3445 12.8334 4.08333 12.5722 4.08333 12.2501C4.08333 11.9279 4.3445 11.6667 4.66667 11.6667C4.98883 11.6667 5.25 11.9279 5.25 12.2501ZM11.6667 12.2501C11.6667 12.5722 11.4055 12.8334 11.0833 12.8334C10.7612 12.8334 10.5 12.5722 10.5 12.2501C10.5 11.9279 10.7612 11.6667 11.0833 11.6667C11.4055 11.6667 11.6667 11.9279 11.6667 12.2501Z",
    stroke: "#6A747F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7905_5555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRevenue);
export default __webpack_public_path__ + "static/media/img_revenue.d959cea06276b7cb2dc09150a39106fe.svg";
export { ForwardRef as ReactComponent };